import { Message } from "primereact/message";

export default function NoRegionsMessage() {

    const messageContent = (
        <div className="message-content">
            <i className="pi pi-info-circle" /> <span>Нет доступных регионов</span>
        </div>
    );

    return (
        <Message
            className="no-regions-message"
            severity={undefined}
            content={messageContent}
        />
    )
}
